import { type CareerCardProps } from '3-components/Cards/CardCareer/CardCareer';
import { type CareerListingQuery } from 'cms/cms';
import HTMLReactParser from 'html-react-parser';
import { resolveCategoriesToBadges } from './badgeResolver';
import { resolveImageReferenceToImage } from './imageResolver';
import type { ContentModelReference } from 'cms/cms-types';
import { resolveDate } from './dateResolver';

export type CareerPage = NonNullable<CareerListingQuery['CareerPage']>;
export type CareerPageItems = NonNullable<CareerPage['items']>;
export interface CareerCardResolverSettings {
    minReadSuffix: string;
}

export const resolveCareerPagesToCareerCards = (items: CareerPageItems): CareerCardProps[] => {
    return items.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const { Name, PreviewTitle, PreviewDescription, Department, Location, EmploymentType, PreviewImage, CareerPublishDate, ContentLink } = item as NonNullable<typeof item>;
        const tags = resolveCategoriesToBadges(Department);
        const imgSrcSets = [480, 767];
        const img = resolveImageReferenceToImage(PreviewImage as ContentModelReference, '?width=460', imgSrcSets);
        const date = resolveDate(CareerPublishDate);

        const mapCategoryArrayToString = <T extends { Name?: string | null }>(
            arr?: (T | null)[] | null
        ): string | undefined => {
            if (!arr) {
                return undefined;
            }

            const names = arr
                .filter((c): c is T => {
                    return c !== null && typeof c.Name === 'string';
                })
                .map(c => {
                    return c.Name!;
                });

            return names.length > 0 ? names.join(', ') : undefined;
        };

        return {
            ...(ContentLink?.Url && { link: { href: ContentLink.Url } }),
            title: PreviewTitle || Name as string,
            ...(PreviewDescription && { children: HTMLReactParser(PreviewDescription as string) }),
            tags,
            ...(img && { img }),
            date,
            location: mapCategoryArrayToString(Location),
            department: mapCategoryArrayToString(Department),
            employmentType: mapCategoryArrayToString(EmploymentType),
        };
    });
};
